<div 
    *ngIf="isLoading$ | async"
    class="loader-full"
>
    <div class="loader-container d-flex align-items-center justify-content-center">
        <div class="loader"></div>
        <p class="loader-text mb-0 text-white" *ngIf="loadingMessage$ | async as message">{{ message }}</p>
    </div>
</div>